<template>
	<div class="character">
		<div class="hearts">
			<div v-for="i in character.life_max" class="heart" :class="{ empty: i > character.life }"></div>
		</div>
		<div class="avatar" :class="animation">
			<div class="name">{{ character.name }}</div>
			<div class="head" :class="character.slug"></div>

			<div v-if="attack !== null" class="total attack" title="Attack">{{ attack }}</div>
			<div v-if="defence !== null" class="total defence" title="Defence">{{ defence }}</div>

			<div v-if="stats" class="stats">
				<div v-for="stat in stats" class="stat" :class="[ stat.type, stat.element ]">{{ stat.value }}</div>
			</div>

			<div class="animation"><div class="image"></div></div>
		</div>
		<!-- <div v-if="character.level" class="level">Level {{ character.level }}</div> -->
	</div>
</template>

<script>
export default {
	name: 'character',
	data() {
		return {
			animation: false
		}
	},
	props: {
		character: { default: null },
	},
	computed: {
		stats() {
			if (this.character.cards) {
				let stats = [
					{ type: 'attack', element: 'fire', value: 0 },
					{ type: 'attack', element: 'ice', value: 0 },
					{ type: 'attack', element: 'electric', value: 0 },
					{ type: 'defence', element: 'fire', value: 0 },
					{ type: 'defence', element: 'ice', value: 0 },
					{ type: 'defence', element: 'electric', value: 0 }
				]

				this.character.cards.forEach((card) => {
					card.attributes.forEach((a) => {
						let stat = stats.find((s) => s.type === a.type && s.element === a.element)
						stat.value += 1
					})
				})

				return stats
			}
			return null
		},
		attack() {
			if (this.character.cards) {
				let n = 0
				this.character.cards.forEach((card) => {
					n += card.attributes.filter((a) => a.type === 'attack').length
				})
				return n
			}
			return null
		},
		defence() {
			if (this.character.cards) {
				let n = 0
				this.character.cards.forEach((card) => {
					n += card.attributes.filter((a) => a.type === 'defence').length
				})
				return n
			}
			return null
		}
	},
	watch: {
		'character.life'(newValue, oldValue) {
			if (newValue < oldValue) {
				this.animation = 'hit'
				setTimeout(() => {
					this.animation = false
				}, 400)
			}
		},
	}
}
</script>

<style lang="stylus" scoped>
@import '../../assets/css/variables'

.character
	width card_width
	height card_height
	.avatar
		width 100%
		height 100%
		border 2px solid light
		background-color darken(dark, 25%)
		flex center center
		border-radius 8px
		color light
		transition transform 0.1s easeOutQuart
		&:hover
			.stats
				display flex
		&.hit
			transform scale(0.95)
			.animation
				background-color alpha(red, 25%)
				.image
					position absolute
					left 50%
					top 50%
					transform translate(-50%, -50%) scale(2)
					width 188px
					height 188px
					background url('../../assets/img/hit.png') left top no-repeat
					background-size (188px * 14) auto
					animation hit 0.4s steps(14) forwards
		.name
			position absolute
			left 8px
			top 16px
			right 8px
			text-align center
			font-size 2.4rem
		.head
			absolute 0
			border-radius 5px
			background center bottom 16px no-repeat
			background-size 90% auto
			&.cowled
				background-image url('../../assets/img/characters/cowled.svg')
			&.fox-head
				background-image url('../../assets/img/characters/fox-head.svg')
			&.lizardman
				background-image url('../../assets/img/characters/lizardman.svg')
			&.horned-reptile
				background-image url('../../assets/img/characters/horned-reptile.svg')
			&.vampire-dracula
				background-image url('../../assets/img/characters/vampire-dracula.svg')
			&.mummy-head
				background-image url('../../assets/img/characters/mummy-head.svg')
			&.kenku-head
				background-image url('../../assets/img/characters/kenku-head.svg')
			&.snake-bite
				background-image url('../../assets/img/characters/snake-bite.svg')
			&.hood
				background-image url('../../assets/img/characters/hood.svg')
			&.ninja-mask
				background-image url('../../assets/img/characters/ninja-mask.svg')
			&.barbute
				background-image url('../../assets/img/characters/barbute.svg')
			&.alien-stare
				background-image url('../../assets/img/characters/alien-stare.svg')
			&.ninja-head
				background-image url('../../assets/img/characters/ninja-head.svg')
			&.bird-mask
				background-image url('../../assets/img/characters/bird-mask.svg')
			&.crowned-skull
				background-image url('../../assets/img/characters/crowned-skull.svg')
			&.female-vampire
				background-image url('../../assets/img/characters/female-vampire.svg')
			&.goblin-head
				background-image url('../../assets/img/characters/goblin-head.svg')
			&.golem-head
				background-image url('../../assets/img/characters/golem-head.svg')


		.total
			position absolute
			bottom -16px
			background-color darken(dark, 25%)
			box-shadow 0 0 0 2px light
			width 40px
			height 40px
			margin 4px 0
			line-height (@height + 2px)
			text-align center
			&.attack
				left -16px
				border-radius 50%
			&.defence
				right -16px
				border-radius 2px
		.animation
			absolute 0
			border-radius 8px
		
		.stats
			position absolute
			top 0
			left calc(100% + 16px)
			flex flex-start flex-start
			flex-wrap wrap
			width ((32px + 4px * 2) * 3 + 32px)
			background-color darken(dark, 25%)
			padding 16px
			border-radius 8px
			box-shadow 0 0 0 2px light
			z-index 2
			display none
			.stat
				width 32px
				height 32px
				margin 4px
				text-align center
				line-height (@height + 2px)
				&.attack
					border-radius 50%
				&.defence
					border-radius 2px
				&.fire
					background-color #FF5722
				&.ice
					background-color #03A9F4
				&.electric
					background-color #FFC107
					
	.hearts
		position absolute
		left 50%
		bottom calc(100% + 16px)
		transform translateX(-50%)
		// height 24px
		width (26px * 10)
		// flex flex-start flex-start
		flex center center
		align-content flex-start
		flex-wrap wrap
		.heart
			width 24px
			height 24px
			margin 0 1px
			flex-shrink 0
			background url('../../assets/img/heart-full.svg') center center no-repeat
			background-size 100%
			&.empty
				background url('../../assets/img/heart-empty.svg') center center no-repeat
	.level
		position absolute
		left 0
		right 0
		top calc(100% + 8px)
		text-align center
		font-size 2rem
	

@keyframes hit
	0%
		background-position 0 top
	100%
		background-position -(188px * 14) top


</style>
